// Copyright (c) Meta Platforms, Inc. and affiliates.

import * as stylex from '@stylexjs/stylex';

/**
 * Scoped marker for RadioListItem ancestor selectors.
 * Prevents hover styles from leaking from parent containers.
 */
export const radioScope = {
  xklqth5: "xklqth5",
  $$css: true
};